export default {"src":"/_next/static/media/VendorManagement.3631b0f6.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};